export enum ShopRoutes {
  ShopperExperiences = 'shopper-experiences',
  RankingStrategy = 'ranking-strategy',
  SocialDiscovery = 'social-discovery',
  Stories = 'stories',
  Collections = 'collections',
}
